export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-server-line',
      title: 'Suporte Especializado em Data Center',
      description: 'Infraestrutura completa de data center em Manaus com monitoramento 24/7, redundância de energia e conectividade de alta velocidade. Nossa equipe especializada garante a disponibilidade e segurança dos seus dados com tecnologia de ponta e atendimento personalizado.',
      features: ['Monitoramento 24/7', 'Redundância de Energia', 'Conectividade Premium']
    },
    {
      icon: 'ri-hard-drive-3-line',
      title: 'Backup Corporativo Local e em Nuvem',
      description: 'Soluções completas de backup corporativo com armazenamento local em Manaus e replicação em nuvem. Proteja seus dados críticos com cópias automáticas, criptografia avançada e recuperação rápida em caso de necessidade, tudo com preço fixo em reais.',
      features: ['Backup Automático', 'Criptografia Avançada', 'Recuperação Rápida']
    },
    {
      icon: 'ri-cloud-line',
      title: 'Hospedagem de Servidores Virtuais',
      description: 'Servidores virtuais de alta performance hospedados em nossa infraestrutura própria em Manaus. Escalabilidade sob demanda, recursos dedicados e suporte técnico especializado para garantir que suas aplicações estejam sempre disponíveis e performáticas.',
      features: ['Alta Performance', 'Escalabilidade', 'Recursos Dedicados']
    }
  ];

  return (
    <section id="servicos" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#0B3A6E] mb-4">
            Nossos Serviços
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Soluções completas de data center, backup corporativo e hospedagem de servidores virtuais, com infraestrutura própria e suporte especializado.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:border-[#F5A623] transform hover:-translate-y-2"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-[#0B3A6E] to-[#1a5a9e] rounded-lg flex items-center justify-center mb-6">
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-[#0B3A6E] mb-4">
                {service.title}
              </h3>
              
              <p className="text-gray-600 mb-6 leading-relaxed text-sm">
                {service.description}
              </p>
              
              <ul className="space-y-3">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center text-sm text-gray-700">
                    <i className="ri-check-line text-[#F5A623] text-lg mr-2"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}